import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
  AfterViewInit,
} from '@angular/core';
import { RowHeightService } from '../../service/rowheight.service';

function get<T, Default>(
  object: T,
  path: string | string[],
  defaultValue?: Default
): any {
  const keys = Array.isArray(path) ? path : path.split('.');
  let result: any = object;
  for (const key of keys) {
    result = result && key in result ? result[key] : undefined;
    if (result === undefined) {
      return defaultValue;
    }
  }
  return result;
}

@Component({
  selector: '[stdoutTableRow]',
  template: `
    <td
      #tdElement
      *ngFor="let column of columns; let colIndex = index"
      [ngStyle]="{ width: getWidth(column), 'max-width': getWidth(column) }"
      [ngClass]="getTdClasses(column)"
      [style.opacity]="column.selected ? 0.5 : 1"
    >
      <span
        *ngIf="column.cellTemplate"
        [ngTemplateOutletContext]="{ column: column, item: item, index: index }"
        [ngTemplateOutlet]="column.cellTemplate"
      >
      </span>
      <span
        *ngIf="!column.cellTemplate"
        [textContent]="getPropertyFromKeys(column.property)"
      >
      </span>
    </td>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableRowComponent implements AfterViewInit {
  @Input() item: any;
  @Input() index!: number;
  @Input() columns: any;
  constructor(private rowHeightService: RowHeightService) {}
  getTdClasses(column: any) {
    const classes: any = {
      'py-2 px-1 md:!py-2.5 md:!px-3.5 break-words max-w-sm': true,
    };
    if (column?.classes) {
      classes[column.classes] = true;
    }

    return classes;
  }

  getPropertyFromKeys(key: any) {
    return get(this.item, key);
  }

  getWidth(column: any) {
    if (column.width) {
      return `${column.width}px`;
    }
    return 'auto';
  }

  @ViewChildren('tdElement') tdElements!: QueryList<ElementRef>;

  ngAfterViewInit() {
    setTimeout(() => {
      const tdArray = this.tdElements.toArray();
      const rowMap = new Map<number, ElementRef[]>();

      tdArray.forEach((tdElement, index) => {
        const rowElement = tdElement.nativeElement.parentElement;
        const rowIndex = Array.from(rowElement.parentElement.children).indexOf(
          rowElement
        );
        if (!rowMap.has(rowIndex)) {
          rowMap.set(rowIndex, []);
        }
        rowMap.get(rowIndex)!.push(tdElement);
      });

      for (const [rowIndex, tds] of rowMap.entries()) {
        let maxHeight = 0;
        for (const td of tds) {
          const height = td.nativeElement.getBoundingClientRect().height;
          if (height > maxHeight) {
            maxHeight = height;
          }
        }
        const roundedHeight = parseFloat(maxHeight.toFixed(1));

        this.rowHeightService.setRowHeight(rowIndex, roundedHeight);
      }
    });
  }
}
